// Categorie (F1): enum fisso, deve combaciare con ALLOWED_CATEGORIES backend.
// Condiviso tra main.ts (select dropdown) e map.ts (pin colorati): unica
// fonte per evitare che le due UI vadano fuori sincrono su icona/colore.

import type { IconName } from "./icons";

export interface CategoryDef {
  value: string;
  label: string;
  icon: IconName;
  // Colore fisso (non legato al tema): identifica la categoria sul pin mappa
  // a colpo d'occhio, indipendentemente dal tema colore scelto nelle impostazioni.
  color: string;
}

export const CATEGORIES: CategoryDef[] = [
  { value: "amici", label: "Amici", icon: "groups", color: "#e0735f" },
  { value: "famiglia", label: "Famiglia", icon: "family_restroom", color: "#3d9970" },
  { value: "casa", label: "Casa", icon: "home", color: "#4f7fc4" },
  { value: "viaggi", label: "Viaggi", icon: "flight_takeoff", color: "#d99a34" },
  { value: "cibo", label: "Cibo", icon: "restaurant", color: "#c2548a" },
  { value: "eventi", label: "Eventi", icon: "celebration", color: "#8e5cc8" },
  { value: "natura", label: "Natura", icon: "park", color: "#2f9e8f" },
];
